
export default {
    name: "LocaleSwitcher",
    data() {
        return { langs: ["fr", "en"] };
    }
};
